import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import api from "../api";
import "../styles/ForgotPassword.css";

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState("");
  const [feedback, setFeedback] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFeedback("");
    if (!email) {
      setFeedback("Please enter a valid email address.");
      return;
    }

    try {
      await api.post("/request_password_reset/", { email }, { withCredentials: true });
      setFeedback(`A password reset link has been sent to ${email}. Please check your inbox.`);
    } catch (error) {
      setFeedback(error?.response?.data?.message || error.message);
    }
  };

  return (
    <div className="forgot-password-body">
      <div className="forgot-password-container">
        <div className="forgot-password-form">
          <h1>Reset Your Password</h1>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <input
                type="email"
                placeholder="Enter email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <button type="submit" className="submit-button">Send Reset Link</button>
            <button type="button" className="cancel-button" onClick={() => navigate("/signin")}>Cancel</button>
          </form>
          {feedback && <p className="error-message">{feedback}</p>}
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
